// event services
const selectEventServices = state => state.getIn(['bookingModule', 'eventServices', 'list']);

const selectEventServicesLoading = state =>
  state.getIn(['bookingModule', 'eventServices', 'isLoading']);

export {
  // event services
  selectEventServices,
  selectEventServicesLoading,
};
